import gql from "graphql-tag";

export const CREATE_MAIL_SETS = gql`
	mutation CreateMailSet(
		$description: String!
		$template: String!
		$datetime: DateTime!
	) {
		createMailSet(
			input: {
				description: $description
				template: $template
				scheduledDateTime: $datetime
			}
		) {
			presignedUrl
		}
	}
`;
